"use client";

import { usePathname } from "next/navigation";
import DownloadIcon from "./components/DownloadIcon";
import AudioIcon from "./components/AudioIcon";
import { useAudio } from "./contexts/AudioContext";
import PauseIcon from "./components/PauseIcon";
import YoutubeGreyLogo from "@/components/icons/YouTubeGreyLogo";
import { LocaleCode, localeStrings } from "@/translations/config";

const englishSubtitleStrings = { date: "April 3rd 2025", listen: "Listen", pause: "Pause", watch: "Watch" };

export default function HeaderSubtitle() {
  const pathname = usePathname();
  const { togglePlayPause, isPlaying } = useAudio();
  // Treat translated versions (/es, /es/summary, ...) like their English counterparts
  const localeMatch = (pathname ?? "/").match(/^\/(es|fr|it|ja)(?=\/|$)/);
  const basePathname = (pathname ?? "/").replace(/^\/(es|fr|it|ja)(?=\/|$)/, '') || '/';
  const strings = localeMatch ? localeStrings[localeMatch[1] as LocaleCode].headerSubtitle : englishSubtitleStrings;
  return <div>
    {(basePathname === "/" || basePathname?.includes("/supplements/") || basePathname === "/summary") && <>
      <h2 className="mt-[-3px] mb-[10px] not-italic text-[21px] md:text-[24px] leading-[1.4] font-normal bg-[var(--vivid-background)] w-fit relative pb-[10px]" style={{ zIndex: 1 }}>
        <div className="md:hidden">
          {strings.date}
        </div>
        <div className="flex items-center font-bold md:hidden mb-2">
          <a target="_blank" href="/ai-2027.pdf" className="flex items-center no-underline">
            <DownloadIcon /> <span className="ml-2">PDF</span> </a>
          <div className="w-[1px] h-[16px] bg-black mx-2" />
          <span className="cursor-pointer flex items-center" onClick={togglePlayPause}>
            {isPlaying ? <PauseIcon /> : <AudioIcon />}
            <span className="ml-2">{isPlaying ? strings.pause : strings.listen}</span>
          </span>
          <div className="w-[1px] h-[16px] bg-black mx-2" />
          <a target="_blank" href="https://www.youtube.com/watch?v=5KVDDfAkRgc" className="flex items-center no-underline">
            <YoutubeGreyLogo /> <span className="ml-2">{strings.watch}</span>
          </a>
        </div>
        <span className="tracking-[-1.2px]">Daniel&nbsp;Kokotajlo, Scott&nbsp;Alexander, Thomas&nbsp;Larsen, Eli&nbsp;Lifland, Romeo&nbsp;Dean</span>
      </h2>
    </>}
  </div>
}